import type { IssueWorkflowOutDto } from 'shared/domain/workflow/types';
import {
  defaultConfig,
  generateHeaders,
  parseResponse,
} from '../../helpers/httpRequests';
import { HeadersData } from '../factories/types';
import { pull } from '../pull';

export const fetchIssueWorkflows = (
  data: HeadersData,
  controller: AbortController
): Promise<IssueWorkflowOutDto[]> | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }

  const builtUrl = `${data.api}/v2/project/${data.projectId}/workflow`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parseResponse) as Promise<IssueWorkflowOutDto[]>;
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
